/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');

var HeaderBarCellView = require('./HeaderBarCellView');

require('./HeaderBarBodyView.css');

module.exports = Marionette.CollectionView.extend({
  className: 'header-bar-body-view',

  getChildView: function(model) {
    if (model.get('headerCell')) {
      return model.get('headerCell');
    }
    return HeaderBarCellView;
  },

  childViewOptions: function(model, index) {
    return {
      dataModel: this.model,
      columns: this.collection,
      childIndex: index
    };
  }
});
